/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    container: {},
    nestedAccordion: {
      paddingLeft: 4,
    },
    internalButton: {},
    internalButtonIcon: {
      color: 'grey',
      marginRight: 2,
    },
    leafButton: {
      color: 'black',
      paddingLeft: 8,
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  parts: ['container', 'nestedAccordion', 'internalButton', 'leafButtonIcon', 'leafButton'],
};
